import angular from "angular";
import _ from "lodash";
import { FolderStatusCodes, FolderTypeCodes } from "@common/model/documentFolder";
import { Util } from "@common/util";
import { Form, WorkflowActions } from "@common/model/form";
import { PermissionsEnum, TargetEnum } from "@common/model/subject";
import { RoleTypeEnum } from "@common/model/serviceNote";
import { PostTypeEnums } from "@common/model/_adocument";
import { convertibleTypes, MODULES, MENU_ACTIONS, SIGNATURE_FLOW_UNITS } from "@common/model/constants";
import { IAppRootScopeService } from "@/app/app.definition";
import { BroadcastService } from "@common/service/broadcast.service";
import { FormService } from "@common/service/form.service";


export const PERMISSION_MENU_ACTIONS_MAPING = {
    // create: [MENU_ACTIONS.CREATE],
    // createOnBehalf: true
    delete: [MENU_ACTIONS.DELETE],
    freeze: [MENU_ACTIONS.FREEZE_TEAM],
    share: [MENU_ACTIONS.SHARE],
    update: [MENU_ACTIONS.EDIT_TEAM_INFO, MENU_ACTIONS.MANAGE_CARE_RECIPIENTS],
};
export class EcvMenuOptions {
    action: string;
    icon: string;
    text: string;
    color: string;
    disabled: boolean;
    subOptions: EcvMenuOptions[];
    hoverTooltip: string;

    constructor(action: string, icon: string, text: string, color: string, disabled: boolean, subOptions: EcvMenuOptions[] | null, hoverTooltip: string | null) {
        if (!action) {
            console.error("EcvMenuOptions: Missing name");
        }

        this.action = action;
        this.disabled = disabled;
        !!icon && (this.icon = icon);
        !!text && (this.text = text);
        !!color && (this.color = color);
        !!subOptions && (this.subOptions = subOptions);
        !!hoverTooltip && (this.hoverTooltip = hoverTooltip);
    }
}

export class EcvContextMenuOptionsList {
    options: Array<EcvMenuOptions>;
    contextMenu: IEcvContextMenu;
    shouldReload: boolean;
    subOptions: EcvMenuOptions[];
    isActiveAssignor?(form: Form): boolean;
    currentUserSameOrgActiveAssignee?(form: Form): boolean;
    currentUserActiveAssignee?(form: Form): boolean;
    isAssignor?(form: Form): boolean;
    getActiveAssigneeNotCurrentUser?(form: Form): boolean;
    userCanShare?(form: Form): boolean;

    constructor(contextMenu: IEcvContextMenu) {
        if (!contextMenu) {
            console.log("EcvContextMenuOptionsList: missing contextMenu");
        }

        !!contextMenu && (this.contextMenu = contextMenu);
    }
}

class CareItemMenu extends EcvContextMenuOptionsList {
    constructor(contextMenu: IEcvContextMenu) {
        super(contextMenu);
    }

    options = [
        new EcvMenuOptions(
            MENU_ACTIONS.OPEN,
            "fa fa-eye",
            "VIEW DETAILS",
            "option-orange",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.IMPORTANT,
            "fa fa-warning",
            "MARK AS IMPORTANT",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.UNIMPORTANT,
            "fa fa-warning",
            "MARK AS UNIMPORTANT",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.READ,
            "fa fa-check",
            "MARK AS READ",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DELETE,
            "fa fa-trash",
            "REMOVE",
            "option-red",
            false,
            null,
            null
        ),
    ];
}

class FolderMenu extends EcvContextMenuOptionsList {
    constructor(contextMenu: IEcvContextMenu) {
        super(contextMenu);
    }

    showToast = (opt) => {
        let msg;
        if (
            _.includes([MENU_ACTIONS.RENAME, MENU_ACTIONS.MOVE], opt.action) ||
            (opt.action == MENU_ACTIONS.DELETE &&
                !this.contextMenu.docFolderSvc.isTeamMember(
                    this.contextMenu.docFolderSvc.isActionAllowed(
                        this.contextMenu.item.allowedOperation,
                        FolderStatusCodes.FOLDER_DELETE
                    ),
                    this.contextMenu.item,
                    false
                ))
        ) {
            if (
                this.contextMenu.item.folderType ==
                FolderTypeCodes.SYSTEM_SUBJECT
            ) {
                msg = "You cannot " + opt.text.toLowerCase() + " this Folder.";
            } else if (
                this.contextMenu.item.folderType == FolderTypeCodes.SUBJECT
            ) {
                msg = "You are not authorized to perform this action.";
            } else {
                msg =
                    "System Folders cannot be " + opt.text.toLowerCase() + "d.";
            }
        } else if (opt.action == MENU_ACTIONS.DELETE) {
            msg = Util.DISABLED_DELETE_BUTTON_HOVER_TEXT;
        }
        toastr.success(msg);
    };

    options = [
        new EcvMenuOptions(
            MENU_ACTIONS.OPEN,
            "fa fa-folder-open",
            "OPEN",
            "option-orange",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.RENAME,
            "fa fa-pencil",
            "RENAME",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.MOVE,
            "fa fa-arrows",
            "MOVE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DELETE,
            "fa fa-trash",
            "DELETE",
            "option-red",
            false,
            null,
            null
        ),
    ];
}

class DocumentMenu extends EcvContextMenuOptionsList {
    constructor(contextMenu: IEcvContextMenu) {
        super(contextMenu);
    }

    showToast = (opt) => {
        let msg;
        let sub = this.contextMenu.item.subject;
        if (opt.action == MENU_ACTIONS.SHARE) {
            let dispAs = this.contextMenu.item.postType.toLowerCase();
            msg = this.contextMenu.$_document.getRestrictedSharingMsg(
                sub,
                this.contextMenu.item,
                dispAs,
                this.contextMenu.user.userId
            );
        } else if (
            !!sub &&
            (sub.isFrozen || sub.isFormerTeamMember) &&
            [MENU_ACTIONS.DELETE, MENU_ACTIONS.SHAREABLE_LINK].includes(
                opt.action
            )
        ) {
            msg = "This action is available only for an active Team.";
        } else if (
            !sub &&
            [MENU_ACTIONS.DELETE, MENU_ACTIONS.SHAREABLE_LINK].includes(
                opt.action
            )
        ) {
            msg = "This action is available only permited to admin ";
        } else if (
            !this.contextMenu.isEnterpriseUserAllwDel &&
            opt.action == MENU_ACTIONS.DELETE
        ) {
            msg =
                "Please contact the Team Captain, a Co-captain, or the owner of this document to have them delete it.";
        }
        toastr.success(msg);
    };

    subOptions = [
        new EcvMenuOptions(
            MENU_ACTIONS.SET_UP_SIGN,
            "fa fa-cogs",
            "SET UP SIGNATURES",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.APPLY_TEMPLATE,
            "fa fa-magic",
            "APPLY SIGNATURE TEMPLATE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.REVIEW_SIGN,
            "fa fa-eye",
            "REVIEW SIGNATURES",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.SIGN_DOC,
            "fa fa-pencil-square-o",
            "SIGN THE DOCUMENT",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DOWNLOAD_SIGN,
            "fa fa-download",
            "DOWNLOAD SIGNED COPY",
            "",
            false,
            null,
            null
        ),
    ];
    options = [
        new EcvMenuOptions(
            MENU_ACTIONS.OPEN,
            "fa fa-file-text-o",
            "VIEW DETAILS",
            "option-orange",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.SHARE,
            "fa fa-share-alt",
            "SHARE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.VIEW,
            "fa fa-eye",
            "VIEW IN BROWSER",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.VIEW_FORM,
            "fa fa-file-text icon-form",
            "VIEW FORM",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DOWNLOAD,
            "fa fa-download",
            "DOWNLOAD FILE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.EDIT_DESCRIPTION,
            "fa fa-pencil-square-o",
            "EDIT DESCRIPTION",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.SHAREABLE_LINK,
            "fa fa-link",
            "GET SHAREABLE LINK",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.SIGNATURE,
            "fa fa-pencil-square-o",
            "SIGNATURE",
            "",
            false,
            this.subOptions,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DOWNLOAD_SIGN,
            "fa fa-download",
            "DOWNLOAD SIGNED COPY",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.RENAME,
            "fa fa-pencil",
            "RENAME",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.MOVE,
            "fa fa-arrows",
            "MOVE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.COPY,
            "fa fa-clone",
            "COPY",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.REGENERATE_SUMMARY,
            "ai-icon fa fa-magic",
            "Regenerate Summary",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DELETE,
            "fa fa-trash",
            "DELETE",
            "option-red",
            false,
            null,
            null
        ),
    ];
}

class FormMenu extends EcvContextMenuOptionsList {
    constructor(contextMenu: IEcvContextMenu) {
        super(contextMenu);
    }

    userCanShare = (form: Form): boolean => {
        return form.userCanShare(this.contextMenu.currentUser.userId);
    };

    currentUserActiveAssignee = (form: Form): boolean => {
        return !!form["assignees"].filter(
            (fu) =>
                ((fu.user.isActive && !fu.user.isFormerTeamMember) ||
                    form.userPerm[PermissionsEnum.SELF_ASSIGN]) &&
                fu.user.id == this.contextMenu.currentUser.userId
        ).length;
    };

    currentUserSameOrgActiveAssignee = (form: Form): boolean => {
        return !!form["assignees"].filter(
            (fu) =>
                ((fu.user.isActive && !fu.user.isFormerTeamMember) ||
                    form.userPerm[PermissionsEnum.SELF_ASSIGN]) &&
                fu.user.id == this.contextMenu.currentUser.userId
        ).length;
    };

    isAssignor = (form: Form): any => {
        return !!form.formUsers.find(
            (fu) =>
                fu.role == RoleTypeEnum.ASSIGNOR &&
                fu.user.userId == this.contextMenu.currentUser.userId
        );
    };

    isActiveAssignor = (form: Form): boolean => {
        return !!form.formUsers.find(
            (fu) =>
                fu.role == RoleTypeEnum.ASSIGNOR &&
                !fu.user.isFormerTeamMember &&
                fu.user.userId == this.contextMenu.currentUser.userId
        );
    };

    getActiveAssignee = (form: Form): boolean => {
        return !!form["assignees"].filter(
            (fu) => fu.user.isActive && !fu.user.isFormerTeamMember
        ).length;
    };

    getActiveAssigneeNotCurrentUser = (form: Form): boolean => {
        return !!form["assignees"].filter(
            (fu) =>
                fu.user.isActive &&
                fu.user.id != this.contextMenu.currentUser.userId &&
                !fu.user.isFormerTeamMember
        ).length;
    };

    showToast = (opt) => {
        let msg;
        if (opt.action == MENU_ACTIONS.SHARE) {
            msg = this.contextMenu.$_document.getRestrictedSharingMsg(
                this.contextMenu.item.subject,
                this.contextMenu.item,
                "form",
                this.contextMenu.currentUser.userId
            );
            toastr.success(msg);
        }
        return;
    };

    options = [
        new EcvMenuOptions(
            MENU_ACTIONS.SEND_REMINDER,
            "fa fa-paper-plane",
            "SEND REMINDER",
            "option-green",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.SUBMIT,
            "fa fa-paper-plane",
            "SUBMIT FORM",
            "option-green",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.SHARE,
            "fa fa-share-alt",
            "SHARE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.VIEW,
            "fa fa-eye",
            "VIEW FORM",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.FILL_OUT,
            "fa fa-pencil",
            "FILL FORM",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.EDIT,
            "fa fa-pencil",
            "EDIT FORM",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.ASSIGN_TEAM,
            "fa fa-exchange",
            "ASSIGN TO TEAM",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.BEGIN_DETERMINATION,
            "fa fa-play-circle-o",
            "Begin Determination",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.ASSIGN_SERVICE,
            "fa fa-arrow-right",
            "Assign Service",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DELETE,
            "fa fa-trash",
            "DELETE",
            "option-red",
            false,
            null,
            null
        ),
    ];
}

class SubjectMenu extends EcvContextMenuOptionsList {
    constructor(contextMenu: IEcvContextMenu) {
        super(contextMenu);
        // TODO: test this code properly, moved options initialization here
        this.options = [
            new EcvMenuOptions(
                MENU_ACTIONS.VIEW,
                "fa fa-user-circle",
                "VIEW TEAM",
                "option-orange",
                false,
                null,
                null
            ),
            new EcvMenuOptions(
                MENU_ACTIONS.SELECT,
                "fa fa-user-circle-o",
                "SELECT TEAM",
                "option-orange",
                false,
                null,
                null
            ),
            //new EcvMenuOptions(MENU_ACTIONS.MANAGE_MEMBERS, "fa fa-user-plus", "MANAGE TEAM MEMBERS","",false,null,null),
            new EcvMenuOptions(
                MENU_ACTIONS.GET_COVER_SHEET,
                "fa fa-fax",
                "GET FAX COVER SHEET",
                "",
                false,
                null,
                null
            ),
            new EcvMenuOptions(
                MENU_ACTIONS.EDIT_TEAM_INFO,
                "fa fa-pencil",
                "EDIT TEAM INFO",
                "",
                false,
                null,
                null
            ),
            new EcvMenuOptions(
                MENU_ACTIONS.FREEZE_TEAM,
                "fa fa-snowflake-o",
                (contextMenu.item.isFrozen ? "UN" : "") + "FREEZE TEAM",
                "",
                false,
                null,
                null
            ),
            new EcvMenuOptions(
                MENU_ACTIONS.TRANSFER_OWNERSHIP,
                "econ-transfer icon-swap-user icon",
                "TRANSFER TEAM",
                "",
                false,
                null,
                null
            ),
            new EcvMenuOptions(
                MENU_ACTIONS.MANAGE_CARE_RECIPIENTS,
                "fa fa-user",
                "MANAGE CARE RECIPIENTS",
                "",
                false,
                null,
                null
            ),
            new EcvMenuOptions(
                MENU_ACTIONS.DELETE,
                "fa fa-trash",
                "DELETE",
                "option-red",
                false,
                null,
                null
            ),
        ];
    }
}

class ServiceNoteMenu extends EcvContextMenuOptionsList {
    constructor(contextMenu: IEcvContextMenu) {
        super(contextMenu);
    }

    options = [
        new EcvMenuOptions(
            MENU_ACTIONS.VIEW,
            "fa fa-eye",
            "VIEW NOTE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.SHARE,
            "fa fa-share-alt",
            "SHARE NOTE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.EDIT,
            "fa fa-pencil",
            "EDIT NOTE",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DELETE,
            "fa fa-trash",
            "DE-ACTIVATE",
            "option-red",
            false,
            null,
            null
        ),
    ];
}
class UserOptions extends EcvContextMenuOptionsList {
    constructor(contextMenu: IEcvContextMenu) {
        super(contextMenu);
    }

    showToast = (opt) => {
        if (opt.action == MENU_ACTIONS.EDIT) {
            toastr.success("You cannot edit a deactivated user.");
        }
        return;
    };

    options = [
        new EcvMenuOptions(
            MENU_ACTIONS.EDIT,
            "fa fa-pencil",
            "EDIT",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.ADD_TO_TEAMS,
            "fa fa-user-plus ",
            "Bulk Add to Teams",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.REMOVE_FROM_TEAMS,
            "fa fa-user-times",
            "BULK REMOVE FROM TEAMS",
            "",
            false,
            null,
            null
        ),
        new EcvMenuOptions(
            MENU_ACTIONS.DEACTIVATE,
            "fa fa-trash",
            "DEACTIVATE",
            "option-red",
            false,
            null,
            null
        ),
    ];
}
export interface IEcvContextMenu {
    itemId: any;
    itemType: string;
    item: any;
    menuFor: string;
    selected;
    $_document;
    currentUser;
    containerPrefix;
    isEnterpriseUserAllwDel;
    docFolderSvc;
    user;

    init(): void;
}
class EcvContextMenu implements IEcvContextMenu {
    itemId: any;
    itemType: string;
    item: any;
    menuFor: string;
    docFolderSvc;
    user;
    $_user;
    optionList: EcvContextMenuOptionsList;
    operation: Function;
    $_scope;
    selected;
    $_rootScope: IAppRootScopeService;
    $_document;
    currentUser;
    containerPrefix;
    flag;
    isEnterpriseUserAllwDel: boolean;
    isDashboard: any;
    folder: any;
    placement;
    heading;
    deleteConfirmtation;
    tooltipIsOpen;
    static $inject = [
        "$scope",
        "$rootScope",
        "CacheService",
        "DocumentFolderService",
        "UserService",
        "DocumentService",
        "BroadcastService",
        "TeamPermissionService",
        "FormService",
        "PermissionService",
    ];
    constructor(
        private $scope,
        private $rootScope: IAppRootScopeService,
        private $_cache,
        private $_docFolderSvc,
        private $user,
        private $document,
        private BroadcastService: BroadcastService,
        private $_teamPerm,
        private FormService: FormService,
        private PermissionService
    ) {
        this.docFolderSvc = $_docFolderSvc;
        this.$_user = $user;
        this.$_scope = $scope;
        this.$_rootScope = $rootScope;
        this.$_document = $document;
        this.$_cache = $_cache;
        this.flag = {};
        this.isDashboard = this.$_cache.getFeatures().clientDashboard;
        $scope.$on("$destroy", function () {
            BroadcastService.removeCallBack("other-popovers-hide", $scope.$id);
            BroadcastService.removeCallBack("update-context-menu", $scope.$id);
            BroadcastService.removeCallBack("sub-options-popover-open", $scope.$id);
            BroadcastService.removeCallBack("sub-options-popover-hide", $scope.$id);
        });
    }

    init(): void {
        if (!this.itemType || !this.itemId) {
            console.error(
                "EcvContextMenu: Cannot open context menu for unknown type"
            );
            return;
        }
        if (!this.placement) {
            this.placement = "";
        }
        switch (this.itemType) {
            case "FOLDER":
                this.optionList = new FolderMenu(this);
                break;
            case "DOCUMENT":
                this.optionList = new DocumentMenu(this);
                break;
            case "FORM":
                this.optionList = new FormMenu(this);
                break;
            case "SUBJECT":
                this.optionList = new SubjectMenu(this);
                break;
            case "SERVICE-NOTE":
                this.optionList = new ServiceNoteMenu(this);
                break;
            case "USERS-OPTIONS":
                this.optionList = new UserOptions(this);
                break;
            case "CARE-ITEM-OPTIONS":
                this.optionList = new CareItemMenu(this);
                break;
            default:
                console.error(
                    "EcvContextMenu: Item type of '",
                    this.itemType,
                    "not currently supported"
                );
                break;
        }
        this.currentUser = this.$_cache.getUser();

        if (!!this.containerPrefix) {
            this.containerPrefix = this.containerPrefix.toLowerCase();
        } else {
            this.containerPrefix = "";
        }

        if (this.itemType == "FOLDER") {
            this.heading = "Folder Options";
            this.deleteConfirmtation =
                "Are you sure you want to delete this folder? Click again to delete.";
            this.flag[this.itemId] = false;
            this.$_docFolderSvc
                .checkFolderContents(this.item.id, this.menuFor)
                .then((hasContent) => {
                    let isDisabled = {};
                    isDisabled[MENU_ACTIONS.OPEN] = false;
                    isDisabled[MENU_ACTIONS.RENAME] =
                        !this.$_docFolderSvc.isTeamMember(
                            this.$_docFolderSvc.isActionAllowed(
                                this.item.allowedOperation,
                                FolderStatusCodes.FOLDER_RENAME
                            ),
                            this.item,
                            false
                        );
                    isDisabled[MENU_ACTIONS.MOVE] =
                        !this.$_docFolderSvc.isTeamMember(
                            this.$_docFolderSvc.isActionAllowed(
                                this.item.allowedOperation,
                                FolderStatusCodes.FOLDER_MOVE
                            ),
                            this.item,
                            false
                        );
                    isDisabled[MENU_ACTIONS.DELETE] =
                        !this.$_docFolderSvc.isTeamMember(
                            this.$_docFolderSvc.isActionAllowed(
                                this.item.allowedOperation,
                                FolderStatusCodes.FOLDER_DELETE
                            ),
                            this.item,
                            false
                        ) || hasContent;
                    for (let opt of this.optionList.options) {
                        opt.disabled = isDisabled[opt.action];
                    }
                });
            //Filter out the actions
            if (this.item.folderType == FolderTypeCodes.SHORT_CUT) {
                this.optionList.options = this.optionList.options.filter(
                    (option) => option.action == MENU_ACTIONS.OPEN
                );
            }
            let actionToRemove: string[] = [];
            //Filter out the actions for the RESOURCE_LIBRARY_CHILD
            if (
                this.item.folderType == FolderTypeCodes.RESOURCE_LIBRARY_CHILD
            ) {
                this.PermissionService.isActionAllowed(
                    this.currentUser.partyId,
                    TargetEnum.RESOURCE_LIBRARY_CHILDFOLDER,
                    PermissionsEnum.RENAME
                ).then((value) => {
                    if (!value) {
                        actionToRemove.push(MENU_ACTIONS.RENAME);
                    }
                });
                this.PermissionService.isActionAllowed(
                    this.currentUser.partyId,
                    TargetEnum.RESOURCE_LIBRARY_CHILDFOLDER,
                    PermissionsEnum.DELETE
                )
                    .then((value) => {
                        if (!value) {
                            actionToRemove.push(MENU_ACTIONS.DELETE);
                        }
                    })
                    .finally(() => {
                        this.optionList.options =
                            this.optionList.options.filter(function (option) {
                                return (
                                    actionToRemove.indexOf(option.action) < 0
                                );
                            });
                    });
            }
        }

        if (this.itemType == "CARE-ITEM-OPTIONS") {
            this.heading = "Item Options";
            this.deleteConfirmtation = Util.REMOVE_CAREITEM_MSG;
            let actionToRemove: string[] = [];
            //Remove the mark as read option for form.
            if (this.menuFor === "FORM") {
                actionToRemove.push(MENU_ACTIONS.READ);
            }
            //Remove the mark as read option for already viewed items.
            if (!this.item.active) {
                actionToRemove.push(MENU_ACTIONS.READ);
            }
            // For items already marked as important show “Unmark as Important” and vice versa
            this.item.isImportant
                ? actionToRemove.push(MENU_ACTIONS.IMPORTANT)
                : actionToRemove.push(MENU_ACTIONS.UNIMPORTANT);
            //Filter out the actions
            this.optionList.options = this.optionList.options.filter(function (
                option
            ) {
                return actionToRemove.indexOf(option.action) < 0;
            });
        }

        if (this.itemType == "DOCUMENT") {
            let actionToRemove: string[] = [];
            if (this.item.postType == PostTypeEnums.LINK) {
                actionToRemove.push(MENU_ACTIONS.DOWNLOAD);
            }
            this.flag[this.itemId] = false;
            this.user = this.$_user.getMe();
            let isShareable = this.$_document.isPostShareable(
                this.item,
                this.item.subject,
                this.user.userId
            );
            let shareOpt = this.optionList.options.find(
                (opt) => opt.action == MENU_ACTIONS.SHARE
            );
            shareOpt.disabled = !isShareable;
            let deleteOpt = this.optionList.options.find(
                (opt) => opt.action == MENU_ACTIONS.DELETE
            );
            //Enterprise user allowed to delete document only if he is the owner of the doc or
            // if he is captain/co-captain of the team.
            this.isEnterpriseUserAllwDel =
                this.currentUser.organizationId == 0 ||
                (!!this.item.subject &&
                    (this.item.subject.ownerId == this.user.userId ||
                        this.item.subject.coCaptain)) ||
                this.item.ownerId == this.user.userId ||
                (this.item.userPerm && this.item.userPerm.delete);

            if (!!this.item.subject && this.item.subject.isFrozen) {
                deleteOpt.disabled = true;
                let shareLinkOpt = this.optionList.options.find(
                    (opt) => opt.action == MENU_ACTIONS.SHAREABLE_LINK
                );
                shareLinkOpt.disabled = true;
            } else if (
                this.currentUser.organizationId > 0 &&
                !(
                    this.item.ownerId == this.user.userId ||
                    (!!this.item.subject && this.item.subject.isActiveMember) ||
                    (this.item.userPerm && this.item.userPerm.delete)
                )
            ) {
                deleteOpt.disabled = true;
            } else if (
                _.includes(
                    [PostTypeEnums.DOCUMENT, PostTypeEnums.LINK],
                    this.item.postType
                ) &&
                !this.isEnterpriseUserAllwDel
            ) {
                deleteOpt.disabled = true;
            }

            let parentVm = this.$scope.$parent.postVm;
            if (
                (!parentVm.isEnterpriseDoc &&
                    this.item.ownerId != this.user.userId) ||
                (!(
                    this.item.ownerId == this.user.userId ||
                    (!!this.item.subject && this.item.subject.isActiveMember)
                ) &&
                    !this.item.userPerm.update) ||
                (!!this.item.subject && this.item.subject.isFrozen) ||
                parentVm.titleEditMode == true ||
                this.item.uploading ||
                this.item.failed ||
                !!this.item.permissionEndDate
            ) {
                actionToRemove.push(MENU_ACTIONS.RENAME);
                actionToRemove.push(MENU_ACTIONS.EDIT_DESCRIPTION);
            }

            //Remove open and move actions when in single view page
            if (!!parentVm.defaultExpanded) {
                actionToRemove.push(MENU_ACTIONS.OPEN);
                actionToRemove.push(MENU_ACTIONS.MOVE);
                actionToRemove.push(MENU_ACTIONS.COPY);
            }
            if (!parentVm.defaultExpanded) {
                actionToRemove.push(MENU_ACTIONS.EDIT_DESCRIPTION);
            }

            //Remove move action when in CF page or discussion page
            if (this.menuFor != "document" && this.menuFor != "discussion") {
                actionToRemove.push(MENU_ACTIONS.MOVE);
                actionToRemove.push(MENU_ACTIONS.COPY);
                actionToRemove.push(MENU_ACTIONS.REGENERATE_SUMMARY);
                actionToRemove.push(MENU_ACTIONS.EDIT_DESCRIPTION);
            } else {
                if (
                    !(
                        this.item.ownerId == this.user.userId ||
                        (!!this.item.subject &&
                            this.item.subject.isActiveMember) ||
                        !!this.item.userPerm.update
                    )
                ) {
                    actionToRemove.push(MENU_ACTIONS.MOVE);
                }
                if (this.item.subjectId) {
                    actionToRemove.push(MENU_ACTIONS.COPY);
                    actionToRemove.push(MENU_ACTIONS.REGENERATE_SUMMARY);
                } else {
                    // For Resource lib documents
                    actionToRemove.push(MENU_ACTIONS.SHAREABLE_LINK);
                    if (this.item.userPerm && !this.item.userPerm.delete) {
                        actionToRemove.push(MENU_ACTIONS.DELETE);
                    }
                    // for copy
                    if (this.item.userPerm && !this.item.userPerm.copy) {
                        actionToRemove.push(MENU_ACTIONS.COPY);
                    }
                    // for share
                    if (this.item.userPerm && !this.item.userPerm.share) {
                        actionToRemove.push(MENU_ACTIONS.SHARE);
                    }
                    //Remove regenerate summary actions when in list view page or when user does not have permission
                    if (
                        !parentVm.defaultExpanded ||
                        this.item.postType === "LINK" ||
                        (this.item.userPerm &&
                            !this.item.userPerm.regenerateSummary)
                    ) {
                        actionToRemove.push(MENU_ACTIONS.REGENERATE_SUMMARY);
                    }
                }
            }
            //Remove signature,view in browser, download actions for discussions
            if (this.item.postType == "DISCUSSION") {
                this.heading = "Discussion Options";
                this.deleteConfirmtation =
                    "Are you sure you want to delete this discussion? Click again to delete.";
                let openOpt = this.optionList.options.find(
                    (opt) => opt.action == MENU_ACTIONS.OPEN
                );
                openOpt.icon = "fa fa-comments-o";
                actionToRemove.push(
                    MENU_ACTIONS.SIGNATURE,
                    MENU_ACTIONS.DOWNLOAD,
                    MENU_ACTIONS.VIEW,
                    MENU_ACTIONS.SHAREABLE_LINK,
                    MENU_ACTIONS.DOWNLOAD_SIGN,
                    MENU_ACTIONS.VIEW_FORM,
                    MENU_ACTIONS.EDIT_DESCRIPTION
                );
            } else {
                this.heading = "Document Options";
                this.deleteConfirmtation =
                    this.currentUser.organizationId == 0
                        ? Util.DELETE_CONFIRM
                        : Util.DELETE_CONFIRM_ORG;
                if (
                    !(
                        this.item.permissionType == "OWN" ||
                        (this.item.permissionType == "ACCESS" &&
                            ((!!this.item.subject &&
                                this.item.subject.isActiveMember) ||
                                this.item.userPerm.share))
                    )
                ) {
                    actionToRemove.push(MENU_ACTIONS.SHAREABLE_LINK);
                }
                if (
                    this.item.postType != PostTypeEnums.LINK &&
                    !this.isConvertible()
                ) {
                    actionToRemove.push(MENU_ACTIONS.VIEW);
                }

                if (
                    this.item.permissionType != "ACCESS" &&
                    this.item.permissionType != "OWN"
                ) {
                    actionToRemove.push(MENU_ACTIONS.DOWNLOAD);
                }
                if (!this.item.assignedFormId) {
                    actionToRemove.push(MENU_ACTIONS.VIEW_FORM);
                }

                if (!parentVm.isDocSignSectionActive(false)) {
                    actionToRemove.push(MENU_ACTIONS.SIGNATURE);
                }
                if (
                    (!!this.item.subject &&
                        (this.item.subject.isFrozen ||
                            this.item.subject.isFormerTeamMember)) ||
                    !parentVm.isPDF()
                ) {
                    actionToRemove.push(
                        MENU_ACTIONS.SET_UP_SIGN,
                        MENU_ACTIONS.APPLY_TEMPLATE,
                        MENU_ACTIONS.SIGN_DOC
                    );
                } else {
                    // Check if document is in pending state (signStatus & 16 === 16)
                    if (!parentVm.shouldShowSignDocumentLink()) {
                        actionToRemove.push(MENU_ACTIONS.SIGN_DOC);
                    }
                    if (!parentVm.isDocOwner()) {
                        actionToRemove.push(
                            MENU_ACTIONS.SET_UP_SIGN,
                            MENU_ACTIONS.APPLY_TEMPLATE
                        );
                    } else {
                        if (
                            !parentVm.isLinkActive(
                                this.item.signStatus,
                                SIGNATURE_FLOW_UNITS
                                    .SETUP_SIGN
                            )
                        ) {
                            actionToRemove.push(MENU_ACTIONS.SET_UP_SIGN);
                        }
                        if (
                            !parentVm.isLinkActive(
                                this.item.signStatus,
                                SIGNATURE_FLOW_UNITS
                                    .APPLY_TEMPLATE
                            )
                        ) {
                            actionToRemove.push(MENU_ACTIONS.APPLY_TEMPLATE);
                        }
                    }
                }
                if (
                    !parentVm.isPDF() ||
                    !parentVm.isDocOwner() ||
                    !parentVm.isLinkActive(
                        this.item.signStatus,
                        SIGNATURE_FLOW_UNITS.REVIEW
                    )
                ) {
                    actionToRemove.push(MENU_ACTIONS.REVIEW_SIGN);
                }
                if (!parentVm.showDownloadSignedLink()) {
                    actionToRemove.push(MENU_ACTIONS.DOWNLOAD_SIGN);
                }
            }

            //Filter out the actions
            this.optionList.options = this.optionList.options.filter(function (
                option
            ) {
                return actionToRemove.indexOf(option.action) < 0;
            });
            this.optionList.subOptions = this.optionList.subOptions.filter(
                function (option) {
                    return actionToRemove.indexOf(option.action) < 0;
                }
            );
            let signatureOpt = this.optionList.options.find(
                (opt) => opt.action == "signature"
            );
            if (!!signatureOpt)
                signatureOpt.subOptions = this.optionList.subOptions;
        }

        if (this.itemType == "FORM") {
            let sub = this.item.subject;
            this.heading = "Form Actions";
            this.deleteConfirmtation =
                "Are you sure you want to delete this assigned Form? Click again to delete.";
            this.flag[this.itemId] = false;

            let actionToRemove: string[] = [];
            if (this.item.status == "SUBMITTED") {
                actionToRemove.push(
                    MENU_ACTIONS.SEND_REMINDER,
                    MENU_ACTIONS.FILL_OUT,
                    MENU_ACTIONS.DELETE,
                    MENU_ACTIONS.SUBMIT
                );
                if (!!sub && sub.isFrozen) {
                    actionToRemove.push(
                        MENU_ACTIONS.EDIT,
                        MENU_ACTIONS.ASSIGN_TEAM,
                        MENU_ACTIONS.BEGIN_DETERMINATION,
                        MENU_ACTIONS.ASSIGN_SERVICE
                    );
                } else {
                    let edit = this.$_docFolderSvc.isActionAllowed(
                        this.item.workflowAction,
                        WorkflowActions.EDIT_AFTER_SUBMIT
                    );
                    let pendingMigration = this.$_docFolderSvc.isActionAllowed(
                        this.item.workflowAction,
                        WorkflowActions.PENDING_MIGRATION
                    );
                    if (pendingMigration) {
                        if (
                            !this.optionList.isActiveAssignor(this.item) ||
                            !edit
                        ) {
                            actionToRemove.push(MENU_ACTIONS.EDIT);
                        }
                    } else {
                        if (
                            !this.optionList.currentUserSameOrgActiveAssignee(
                                this.item
                            ) ||
                            !edit
                        ) {
                            actionToRemove.push(MENU_ACTIONS.EDIT);
                        }
                    }
                    if (
                        !this.optionList.isActiveAssignor(this.item) ||
                        !this.$_docFolderSvc.isActionAllowed(
                            this.item.workflowAction,
                            WorkflowActions.PENDING_MIGRATION
                        )
                    ) {
                        actionToRemove.push(MENU_ACTIONS.ASSIGN_TEAM);
                    }
                    if (
                        !this.optionList.currentUserSameOrgActiveAssignee(
                            this.item
                        ) ||
                        !this.$_docFolderSvc.isActionAllowed(
                            this.item.workflowAction,
                            WorkflowActions.BEGIN_DETERMINATION
                        )
                    ) {
                        actionToRemove.push(MENU_ACTIONS.BEGIN_DETERMINATION);
                    }
                    if (
                        !this.optionList.currentUserSameOrgActiveAssignee(
                            this.item
                        ) ||
                        !this.$_docFolderSvc.isActionAllowed(
                            this.item.workflowAction,
                            WorkflowActions.ASSIGN_SERVICE
                        )
                    ) {
                        actionToRemove.push(MENU_ACTIONS.ASSIGN_SERVICE);
                    }
                }
            } else {
                actionToRemove.push(
                    MENU_ACTIONS.EDIT,
                    MENU_ACTIONS.ASSIGN_TEAM,
                    MENU_ACTIONS.BEGIN_DETERMINATION,
                    MENU_ACTIONS.ASSIGN_SERVICE
                );
                if (this.optionList.currentUserActiveAssignee(this.item)) {
                    actionToRemove.push(MENU_ACTIONS.VIEW);
                    if (
                        this.item.status != "COMPLETED" ||
                        !this.FormService.checkSubmitterRole(
                            this.item.formUsers,
                            this.item.roles
                        )
                    ) {
                        actionToRemove.push(MENU_ACTIONS.SUBMIT);
                    }
                } else {
                    actionToRemove.push(
                        MENU_ACTIONS.FILL_OUT,
                        MENU_ACTIONS.SUBMIT
                    );
                }

                if (
                    !this.optionList.isAssignor(this.item) &&
                    (!this.item.userPerm || !this.item.userPerm["delete"])
                ) {
                    actionToRemove.push(MENU_ACTIONS.DELETE);
                }
                if (
                    (!this.optionList.isAssignor(this.item) &&
                        (!this.item.userPerm ||
                            !this.item.userPerm["sendReminder"])) ||
                    !this.optionList.getActiveAssigneeNotCurrentUser(this.item)
                ) {
                    actionToRemove.push(MENU_ACTIONS.SEND_REMINDER);
                }
            }

            //Filter out the actions
            this.optionList.options = this.optionList.options.filter(function (
                option
            ) {
                return actionToRemove.indexOf(option.action) < 0;
            });

            for (let opt of this.optionList.options) {
                if (
                    opt.action == MENU_ACTIONS.SHARE &&
                    !this.optionList.userCanShare(this.item) &&
                    (!this.item.userPerm || !this.item.userPerm["share"])
                ) {
                    opt.disabled = true;
                } else {
                    opt.disabled = false;
                }
            }
        }

        if (this.itemType == "SUBJECT") {
            let amICaptain = this.item.ownerId == this.currentUser.id;
            let isFrozen = !!this.item.isFrozen;
            this.flag[this.itemId] = false;
            let actionToRemove: string[] = [];
            let subjType = "the " + this.item.projectName + " project";
            if (this.item.subjectTypeId == "INDIVIDUAL") {
                this.heading = "Individual Team Actions";
                subjType = this.item.fullName + "'s";
                actionToRemove.push(MENU_ACTIONS.MANAGE_CARE_RECIPIENTS);
            } else {
                if (isFrozen || (!amICaptain && !this.item.coCaptain)) {
                    actionToRemove.push(MENU_ACTIONS.MANAGE_CARE_RECIPIENTS);
                }
                this.heading = "Project Team Actions";
            }
            this.deleteConfirmtation =
                "Are you sure you want to delete " +
                subjType +
                " Team? Click again to delete.";
            //Check for Delete Team action
            if (!amICaptain) {
                actionToRemove.push(MENU_ACTIONS.DELETE);
            }

            let hasActiveTeamMember = false;
            if (this.item.teamMemberList) {
                let activeTeamMembers = this.item.teamMemberList.filter(
                    (member) =>
                        member.isActive == true && !member.isFormerTeamMember
                );
                if (activeTeamMembers.length > 1) {
                    hasActiveTeamMember = true;
                } else {
                    hasActiveTeamMember = false;
                }
            }

            //Check for Edit Team action

            if (!amICaptain) {
                actionToRemove.push(MENU_ACTIONS.FREEZE_TEAM);
            }
            if (isFrozen || !amICaptain || !hasActiveTeamMember) {
                actionToRemove.push(MENU_ACTIONS.TRANSFER_OWNERSHIP);
            }
            if (isFrozen || (!amICaptain && !this.item.coCaptain)) {
                actionToRemove.push(MENU_ACTIONS.EDIT_TEAM_INFO);
            }

            //Check for Get Cover Sheet action
            if (
                isFrozen ||
                !this.$_teamPerm.isModuleAllowedForTeam(
                    this.item,
                    MODULES.COVERSHEET
                )
            ) {
                actionToRemove.push(MENU_ACTIONS.GET_COVER_SHEET);
            }
            if (this.PermissionService.isPermCheckReq) {
                this.PermissionService.isActionAllowed(
                    this.item.teamPartyId,
                    TargetEnum.TEAMMEMBER,
                    PermissionsEnum.TRANSFER_OWNERSHIP
                ).then((data) => {
                    if (data && !isFrozen && hasActiveTeamMember) {
                        actionToRemove = actionToRemove.filter((action) => {
                            return (
                                PermissionsEnum.TRANSFER_OWNERSHIP !== action
                            );
                        });
                    }
                });
                this.PermissionService.getPermissionsForTarget(
                    TargetEnum.TEAM,
                    [this.item.teamPartyId]
                ).then((permissions) => {
                    if (
                        Array.isArray(permissions) &&
                        (permissions.length !== 0 || undefined)
                    ) {
                        Object.keys(PERMISSION_MENU_ACTIONS_MAPING).forEach(
                            (key) => {
                                if (
                                    permissions[0][TargetEnum.TEAM][key] &&
                                    PERMISSION_MENU_ACTIONS_MAPING[key]
                                ) {
                                    PERMISSION_MENU_ACTIONS_MAPING[key].forEach(
                                        (value) => {
                                            actionToRemove =
                                                actionToRemove.filter(
                                                    (action) => {
                                                        return value !== action;
                                                    }
                                                );
                                        }
                                    );
                                }
                            }
                        );
                    }

                    //Filter out the actions
                    if (this.item.subjectTypeId == "INDIVIDUAL") {
                        actionToRemove.push(
                            MENU_ACTIONS.MANAGE_CARE_RECIPIENTS
                        );
                    }
                    this.PermissionService.isActionAllowed(
                        this.item.teamPartyId,
                        TargetEnum.DASHBOARD,
                        PermissionsEnum.LIST
                    )
                        .then((isPermited) => {
                            if (this.isDashboard || isPermited) {
                                actionToRemove.push(MENU_ACTIONS.FREEZE_TEAM);
                                actionToRemove.push(
                                    MENU_ACTIONS.TRANSFER_OWNERSHIP
                                );
                                actionToRemove.push(
                                    MENU_ACTIONS.EDIT_TEAM_INFO
                                );
                                actionToRemove.push(MENU_ACTIONS.DELETE);
                            }
                        })
                        .finally(() => {
                            this.optionList.options =
                                this.optionList.options.filter(function (
                                    option
                                ) {
                                    return (
                                        actionToRemove.indexOf(option.action) <
                                        0
                                    );
                                });
                        });
                });
            } else {
                this.optionList.options = this.optionList.options.filter(
                    function (option) {
                        return actionToRemove.indexOf(option.action) < 0;
                    }
                );
            }
            //Filter out the actions
        }

        if (this.itemType == "SERVICE-NOTE") {
            this.heading = "Service Note Actions";
            this.deleteConfirmtation = Util.NOTE_DELETE_MSG;
            this.flag[this.itemId] = false;
            let actionToRemove: string[] = [];

            if (this.item.deleted) {
                actionToRemove.push(MENU_ACTIONS.DELETE, MENU_ACTIONS.EDIT);
            } else if (!this.item.editAfterSubmit) {
                actionToRemove.push(MENU_ACTIONS.EDIT);
                !this.item.userPerm.delete &&
                    actionToRemove.push(MENU_ACTIONS.DELETE);
            }

            if (!this.item.canShareServiceNote) {
                this.item.userPerm
                    ? !this.item.userPerm.share &&
                    actionToRemove.push(MENU_ACTIONS.SHARE)
                    : actionToRemove.push(MENU_ACTIONS.SHARE);
            }

            //Filter out the actions
            this.optionList.options = this.optionList.options.filter(function (
                option
            ) {
                return actionToRemove.indexOf(option.action) < 0;
            });
        }

        if (this.itemType == "USERS-OPTIONS") {
            this.heading = "User Actions";
            let actionToRemove: string[] = [];

            if (
                !this.item.userPerm.deactivate ||
                this.item.isDeactivated ||
                this.item.id == this.currentUser.userId
            ) {
                actionToRemove.push(MENU_ACTIONS.DEACTIVATE);
            }
            if (!this.item.userPerm.update) {
                actionToRemove.push(MENU_ACTIONS.EDIT);
            }
            if (this.item.isDeactivated) {
                actionToRemove.push(MENU_ACTIONS.ADD_TO_TEAMS);
                actionToRemove.push(MENU_ACTIONS.REMOVE_FROM_TEAMS);
            } else {
                if (!this.item.userPerm.bulkTeamAdd) {
                    actionToRemove.push(MENU_ACTIONS.ADD_TO_TEAMS);
                }
                if (!this.item.userPerm.bulkTeamRemove) {
                    actionToRemove.push(MENU_ACTIONS.REMOVE_FROM_TEAMS);
                }
            }

            //Filter out the actions
            this.optionList.options = this.optionList.options.filter(function (
                option
            ) {
                return actionToRemove.indexOf(option.action) < 0;
            });

            if (this.item.isDeactivated) {
                let editOpt = this.optionList.options.find(
                    (opt) => opt.action == MENU_ACTIONS.EDIT
                );
                editOpt.disabled = true;
            }
        }

        this.BroadcastService.registerCallBack(
            "other-popovers-hide",
            this.$_scope.$id,
            (data) => {
                let id =
                    "#" +
                    this.containerPrefix +
                    this.itemType.toLowerCase() +
                    "-options-" +
                    this.itemId;
                if (!!data && data != id && !!$(id)[0]) {
                    ($($(id)[0].firstElementChild.firstElementChild) as MenuPopover).popover(
                        "hide"
                    );
                    let subPopover = $(id).find("#sub-options-popover");
                    if (subPopover.length > 0) {
                        ($(subPopover[0]) as MenuPopover).popover("hide");
                    }
                }
            }
        );
        this.BroadcastService.registerCallBack(
            "update-context-menu",
            this.$_scope.$id,
            (itemId, subjectId) => {
                if (
                    (!!itemId && itemId == this.itemId) ||
                    (!!subjectId && subjectId == this.item.subjectId)
                ) {
                    this.init();
                }
            }
        );
        this.BroadcastService.registerCallBack(
            "sub-options-popover-open",
            this.$_scope.$id,
            (data) => {
                let id =
                    "#" +
                    this.containerPrefix +
                    this.itemType.toLowerCase() +
                    "-options-" +
                    this.itemId;
                if (!!data && data == id) {
                    angular
                        .element(".ngscroll-container")
                        .css("overflow-y", "hidden");
                }
            }
        );
        this.BroadcastService.registerCallBack(
            "sub-options-popover-hide",
            this.$_scope.$id,
            (data) => {
                let id =
                    "#" +
                    this.containerPrefix +
                    this.itemType.toLowerCase() +
                    "-options-" +
                    this.itemId;
                if (!!data && data == id) {
                    this.selected = false;
                    angular
                        .element(".ngscroll-container")
                        .css("overflow-y", "auto");
                }
            }
        );
    }

    getFileExtension(filename: string) {
        if (!!filename) {
            return filename
                .substring(filename.lastIndexOf(".") + 1)
                .toLowerCase();
        }
        return null;
    }

    isConvertible = (): boolean => {
        return !!convertibleTypes.find(
            (str) => str == this.getFileExtension(this.item.filename)
        );
    };

    openContextMenu = ($event) => {
        $event.preventDefault();
        $event.stopPropagation();
        this.BroadcastService.broadcast("mugshot-tooltip-hide");
        this.BroadcastService.broadcast("badges-tooltip-hide");
    };

    doAction = ($event, operation, document) => {
        ($("#folder-options-popover") as MenuPopover).popover("hide");
        ($("#sub-options-popover") as MenuPopover).popover("hide");
        this.flag[this.itemId] = false;
        this.tooltipIsOpen = false;
        return this.operation($event, operation, document);
    };
}

function contextMenu(): ng.IDirective {
    return {
        restrict: "E",
        replace: true,
        scope: true,
        template: `
                <div class="hide-print context-menu">
                  <a ecv-popover-placement="{{contextMenuVm.placement}}"  ecv-popover-selector="{{contextMenuVm.selector}}"
                  href="javascript:;" ng-click="contextMenuVm.openContextMenu($event)"
                       id="folder-options-popover" class="menu-icon context-menu-button"
                       ecv-popover-container="#{{contextMenuVm.containerPrefix.toLowerCase()}}{{contextMenuVm.itemType.toLowerCase()}}-options-{{contextMenuVm.itemId}}"
                       ecv-popover-template-id="contextMenuTemplate.html"
                        ecv-popover-trigger="click"  popover>
                        <i class="fa fa-ellipsis-v context-menu-icon" aria-hidden="true"></i>
                  </a>
                  <script type="text/ng-template" id="contextMenuTemplate.html">
                    <div id="folder-popover" class="popover-template" data-container="body" data-toggle="popover">
                      <div class="template-title">
                        <strong class="">{{contextMenuVm.heading}}</strong>
                      </div>
                        <div class="template-content">
                            <div class="ngscroll-container menu-content ecv-scrollbar">
                                <ul class="menu-options">
                                    <li ng-repeat="opt in contextMenuVm.optionList.options" uib-tooltip="{{opt.hoverTooltip}}"
                                    tooltip-enable="!!opt.hoverTooltip" tooltip-append-to-body="true" tooltip-is-open="contextMenuVm.tooltipIsOpen">
                                        <div ng-if="!opt.subOptions && opt.action=='delete'" class="stop-click context-delete cursor-pointer {{opt.color}}"
                                           ecv-tooltip-msg ="contextMenuVm.deleteConfirmtation"
                                             ecv-confirm-tooltip
                                             ecv-append-to-body= "'true'"
                                             ecv-outer-class = "'body'"
                                             ecv-flag="contextMenuVm.flag[contextMenuVm.itemId]"
                                             ecv-show-tooltip="!opt.disabled"
                                             ecv-element-class = "'stop-click context-menu-strech-me'"
                                             ng-click="(opt.disabled || contextMenuVm.flag[contextMenuVm.itemId]) && (!opt.disabled && contextMenuVm.doAction($event,opt.action,contextMenuVm.item)) || contextMenuVm.optionList.showToast(opt)" daid="{{opt.text | titleCase}}-link">
                                            <i class="stop-click choose-me-choice-icon {{ opt.icon }}"
                                               ng-if="opt.icon" ></i>
                                            &nbsp;<span class="stop-click"
                                                                    ng-bind="opt.text | titleCase"></span>
                                        </div>
                                        <div ng-if="!opt.subOptions && opt.action!='delete' && opt.action!='downloadSign'" class=" stop-click cursor-pointer "
                                           ng-class="[opt.color, 'action-'+opt.action, {'disabled' : !!opt.disabled}]"
                                             ng-click="(!opt.disabled && contextMenuVm.doAction($event,opt.action,contextMenuVm.item)) || contextMenuVm.optionList.showToast(opt)" daid="{{opt.text | titleCase}}-link">
                                            <i class="stop-click choose-me-choice-icon {{ opt.icon }} action-{{ opt.action }}"
                                               ng-if="opt.icon" ></i>
                                            &nbsp;<span class="stop-click action-{{ opt.action }}"
                                                        ng-bind="opt.text | titleCase"></span>
                                        </div>
                                        <div ng-if="!!opt.subOptions && opt.action!='downloadSign'" ng-class="{'hidden-xs':opt.action =='signature'}" ng-click="contextMenuVm.selected=true;$event.preventDefault();$event.stopPropagation();"
                                           id="sub-options-popover" class="stop-click cursor-pointer"
                                           ng-class="[opt.color,{'option-selected' : !!contextMenuVm.selected}]"
                                           ecv-popover-trigger="click"
                                           ecv-popover-container="#{{contextMenuVm.containerPrefix.toLowerCase()}}{{contextMenuVm.itemType.toLowerCase()}}-options-{{contextMenuVm.itemId}}"
                                           ecv-popover-template-id="contextSubMenuTemplate.html" popover>
                                           <i class="stop-click choose-me-choice-icon {{ opt.icon }}"
                                               ng-if="opt.icon" ></i>
                                            &nbsp;<span class="stop-click"
                                                        ng-bind="opt.text | titleCase"></span>
                                                        <span class="sub-menu-icon" >
                                           <i class="fa fa-chevron-circle-right"></i></span>
                                       </div>
                                       <div ng-if="!opt.subOptions && opt.action =='downloadSign'" ng-click="(!opt.disabled && contextMenuVm.doAction($event,opt.action,contextMenuVm.item))"
                                          id="sub-options-popover" class="visible-xs stop-click cursor-pointer "
                                          ng-class="[opt.color, opt.action, {'disabled' : !!opt.disabled}]">
                                          <i class="stop-click choose-me-choice-icon {{ opt.icon }}"
                                              ng-if="opt.icon" ></i>
                                           &nbsp;<span class="stop-click"
                                                       ng-bind="opt.text | titleCase"></span>
                                                       <span class="sub-menu-icon" >
                                      </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </script>
                <script type="text/ng-template" id="contextSubMenuTemplate.html">
                    <div id="sub-menu-popover" class="popover-template" data-container="body" data-toggle="popover">
                        <div class="template-content">
                        <ul class="menu-options">
                                <li ng-repeat="subopt in opt.subOptions">
                                    <div class="stop-click cursor-pointer {{subopt.color}}"
                                       ng-class="{'disabled' : subopt.disabled}"
                                       ng-click="(!subopt.disabled && contextMenuVm.doAction($event,subopt.action,contextMenuVm.item)) || contextMenuVm.optionList.showToast(opt)">
                                        <i class="stop-click choose-me-choice-icon {{ subopt.icon }}"
                                           ng-if="subopt.icon" ></i>
                                        &nbsp;<span class="stop-click"
                                                    ng-bind="subopt.text | titleCase"></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </script>
                </div>
            `,
        controller: EcvContextMenu,
        controllerAs: "contextMenuVm",
        bindToController: {
            itemId: "=",
            itemType: "@itemType",
            item: "=?item",
            operation: "=",
            menuFor: "@",
            containerPrefix: "@",
            placement: "=?",
            selector: "=?",
        },
        link: (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            controller: IEcvContextMenu
        ): void => {
            controller.init();
        },
    };
}

angular
    .module("eCareVault.common.menuOptions")
    .directive("contextMenu", contextMenu);
